module.exports = __webpack_public_path__ + "img/handraw_expédition- footer copie.0994a25e.svg";